import { Grid2 } from "@mui/material";
import React from "react";
// styles
import styles from "./ChangePassword.module.scss";
import CustomInput from "../../../../../../../GlobalComponents/CustomInput/CustomInput";
import "react-toastify/dist/ReactToastify.css";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";

function NewChangePassword({
  passFormUpdate,
  passFormData,
  currentpassword,
  newpassword,
  confirmpassword,
}) {
  return (
    <>
      <Grid2 className={styles.NewChangePasswordMainContainer}>
        <Grid2 className={styles.DisplayFlex}>
          <Grid2 className={styles.flexBox}>
            <Grid2 className={styles.Icon}>
              <LockOpenOutlinedIcon className={styles.IconColor} />
            </Grid2>
            <Grid2 className={styles.Header}>Security</Grid2>
          </Grid2>
        </Grid2>

        <CustomInput
          title="Current Password"
          placeholder="Enter Current Password"
          required={true}
          value={currentpassword}
          error={passFormData.currentpasswordError}
          setValue={(e, title) => {
            passFormUpdate(e, title);
          }}
          password={true}
          passwordview={true}
        />
        <CustomInput
          title="New Password"
          placeholder="Enter New Password"
          required={true}
          value={newpassword}
          error={passFormData.newpasswordError}
          setValue={(e, title) => {
            passFormUpdate(e, title);
          }}
          password={true}
          errorMessage={
            passFormData.newpasswordError
              ? passFormData.newpasswordErrorMessage
              : null
          }
        />
        <CustomInput
          title="Confirm New Password"
          placeholder="Enter Confirm New Password"
          required={true}
          value={confirmpassword}
          error={passFormData.confirmpasswordError}
          setValue={(e, title) => {
            passFormUpdate(e, title);
          }}
          errorMessage={
            passFormData.confirmpasswordError
              ? passFormData.confirmpasswordErrorMessage
              : ""
          }
          passwordview={true}
          password={true}
        />
      </Grid2>
    </>
  );
}

export default NewChangePassword;
